import { StyleSheet, Text, View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { colors, fontFamily, maxContentWidth, radii, space, spacing, type } from '~/ui/tokens';

const PLATFORMS: { icon: keyof typeof Ionicons.glyphMap; label: string }[] = [
  { icon: 'logo-apple', label: 'iOS — coming soon' },
  { icon: 'logo-google-playstore', label: 'Android — coming soon' },
];

export function ComingSoonStrip() {
  return (
    <View style={styles.strip}>
      <View style={styles.inner}>
        <Text style={styles.text}>The SuiteScanner app is on its way</Text>
        <View style={styles.badges}>
          {PLATFORMS.map((platform) => (
            <View key={platform.label} style={styles.badge}>
              <Ionicons name={platform.icon} size={18} color={colors.ink} />
              <Text style={styles.badgeLabel}>{platform.label}</Text>
            </View>
          ))}
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  strip: {
    // Card white rather than a tint: the section above it is skyTint, and
    // matching tints made the two read as one long band.
    backgroundColor: colors.card,
    borderTopWidth: 1,
    borderTopColor: colors.lineSoft,
  },
  inner: {
    maxWidth: maxContentWidth,
    width: '100%',
    alignSelf: 'center',
    paddingVertical: space.component,
    paddingHorizontal: space.card,
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: space.internal,
  },
  text: {
    fontFamily: fontFamily.semibold,
    ...type.bodyLarge,
    color: colors.ink,
  },
  badges: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: space.compact,
  },
  badge: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: space.related,
    backgroundColor: colors.cream,
    borderWidth: 1,
    borderColor: colors.line,
    borderRadius: radii.full,
    paddingVertical: spacing(1),
    paddingHorizontal: spacing(1.75),
  },
  badgeLabel: {
    fontFamily: fontFamily.medium,
    fontSize: type.bodyRegular.fontSize,
    color: colors.ink,
  },
});
